var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOnline)?_c('v-icon',{attrs:{"title":"Connected","color":"primary","dense":""}},[_vm._v("mdi-access-point-network")]):_c('v-icon',{attrs:{"title":"Disconnected","color":"primary","dense":""}},[_vm._v("mdi-access-point-network-off")])}
var staticRenderFns = []

export { render, staticRenderFns }